module.exports = __webpack_public_path__ + "070e5b2db4e31b2d15af6b243cefbaf3.pdf";